module.exports = __webpack_public_path__ + "media/images/img/tag_company/nri_tag-acd56234c8827c9bac3042aeb33b1e4c.png";